module.exports = __webpack_public_path__ + "static/img/img-educator-feature-3.172a688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-3.png
// module id = Hltj
// module chunks = 18